module.exports = __webpack_public_path__ + "img/13 – 1.47df6355.png";